import { Box } from "@mui/material"
import DarkMode from "./dark-mode/index.jsx"
import Profile from "./profile/index.jsx"
import Organization from "./organization"
import useProfileStore from "../../../../store/profile"
import { useEffect } from "react"
import { useIsMobile } from "../../../../hooks/useIsMobile.js"
import { useRouter } from "next/router.js"
import requests from "../../../../services/requests/index"
import auth from "../../../../lib/auth"

const HeaderContent = () => {
  const router = useRouter()
  if (!auth?.isLoggedIn) {
    auth.logout(router)
  }
  const { getProfile } = requests
  const { profileData, setProfileData } = useProfileStore()
  const isMobile = useIsMobile()

  const authAPi = async () => {
    if (auth?.isLoggedIn) {
      try {
        const res = await getProfile()
        if (res.data.succeed) {
          setProfileData(res.data.value)
        }
      } catch (error) {
        return
      }
    }
  }

  useEffect(() => {
    authAPi()
  }, [])

  return (
    <>
      <DarkMode />
      <Box sx={{ width: "100%", ml: isMobile ? 0 : 1 }} />
      {/* <Credit /> */}
      {profileData?.organizationName && profileData.organizationId !== 1 && (
        <Organization organizationName={profileData?.organizationName} />
      )}
      <Profile />
    </>
  )
}
export default HeaderContent
